export class DetailedError implements Error {
  public name = 'DetailedError';

  public message: string;

  public responseCode: number;

  public responseData: any;

  constructor(message?: string, code?: number, data?: any) {
    this.message = message || '';
    this.responseCode = code || 0;
    this.responseData = data;
  }
}
